import React, { useState, useEffect } from "react";
import { Cloudinary } from "@cloudinary/url-gen";
import { AdvancedImage, lazyload, responsive } from "@cloudinary/react";
import "./Landing.css";

// Initialize Cloudinary instance
const cld = new Cloudinary({
  cloud: {
    cloudName: 'di0r4dirk' // Your cloud name from the URL
  }
});

const filmCards = [
  {
    description: "Giving a platform to marginalized voices and their stories of resilience.",
    image: require('../../assets/film-4-card.png'),
    link: "https://youtu.be/9X-C8kK68EM?si=-fk5LyO3m7T1f1_o",
  },
  {
    description: "Giving a platform to marginalized voices and their stories of resilience.",
    image: require('../../assets/film-3-card.png'),
    link: "https://www.youtube.com/watch?v=TPj5ySaDAaQ&t=1s",
  },
  {
    description: "Exploring grassroots movements that are transforming rural communities for the better.",
    image: require('../../assets/film-2-card.png'),
    link: "https://www.youtube.com/watch?v=Fh5GENKLGaM&t=2s",
  },
  {
    description: "A documentary highlighting the journey of young women breaking barriers in STEM fields.",
    image: require('../../assets/film-1-card.png'),
    link: "https://www.youtube.com/watch?v=F0rWdvJxtEg&t=24s",
  }
];

const Landing = () => {
  const [isHeroLoaded, setIsHeroLoaded] = useState(false);
  const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1920);

  // Track window resize for responsive images
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Get the hero image from Cloudinary with optimizations
  const getOptimizedHeroImage = () => {
    // Your image public ID from the URL (without the file extension)
    const publicId = 'annie-spratt-yrzBgqapG1I-unsplash_tvs9h1';
    
    // Create base image
    const heroImg = cld.image(publicId);
    
    // Determine optimal width based on screen size
    let targetWidth = 1000; // Default large size
    
    if (windowWidth <= 768) {
      targetWidth = 400; // Mobile
    } else if (windowWidth <= 1200) {
      targetWidth = 800; // Tablet
    }
    
    // Apply optimizations
    heroImg
      .format('auto') // Auto-choose best format (WebP if supported)
      .quality('auto:good') // Auto quality (good for hero images)
      .resize(`w_${targetWidth}`); // Resize to optimal width
    
    return heroImg;
  };

  // Get hero image URL for CSS background (fallback)
  const getHeroImageUrl = () => {
    const img = getOptimizedHeroImage();
    return img.toURL();
  };

  // Preload the hero image
  useEffect(() => {
    const preloadHeroImage = () => {
      const img = new Image();
      img.src = getHeroImageUrl();
      img.onload = () => {
        setIsHeroLoaded(true);
      };
      img.onerror = () => {
        console.error('Failed to load hero image');
        setIsHeroLoaded(true); // Continue anyway
      };
    };

    preloadHeroImage();
  }, [windowWidth]);

  return (
    <div className="Landing-hero-container">
      {/* Hero Section with Cloudinary Optimization */}
      <div
        className={`Landing-hero-section ${isHeroLoaded ? 'loaded' : 'loading'}`}
        style={{
          backgroundImage: `url(${getHeroImageUrl()})`,
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat'
        }}
      >
        {/* Optional: Progressive loading with blur-up technique */}
        {!isHeroLoaded && (
          <div className="hero-placeholder">
            {/* You can add a loading spinner or low-quality placeholder here */}
          </div>
        )}
        
        <div className="Landing-overlay">
          <h1 className="landing-title">
            IMPACT STORIES FUND:
          </h1>

          <h1 className="landing-title">
            INVESTING IN STORIES THAT SHAPE THE FUTURE
          </h1>
        </div>
      </div>

      <div className="films-section">
        <div className="films-title-section">
          <h4 className="films-title">
            Our Films
          </h4>
        </div>
        <div className="films-cards-section">
          <div className="film-cards-container row">
            {filmCards.map((card, index) => (
              <div className="film-card col-lg-3 col-md-4" key={index}>
                <a href={card.link} target="_blank" rel="noopener noreferrer">
                  <img 
                    src={card.image} 
                    alt={`Film ${index + 1}`}
                    loading="lazy"
                    decoding="async"
                  />
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Landing;